module.exports = __webpack_public_path__ + "img/share.9c796761.png";